export default {
  template: null,
  // Jornadas completas, por clientId — a do perfil e a da página de resumo.
  byClientId: {},
  // Resumo 360 (dados, patrimônio, reuniões), por clientId.
  overviewByClientId: {},
  // Projeções leves da listagem, por clientId.
  summaries: {},
  // Indicadores da faixa de KPIs. `null` = ainda não vieram do backend; a UI
  // cai no cálculo local sobre os resumos já carregados.
  indicators: null,
  loading: false,
  loadingSummaries: false,
  error: null,
}
